module.exports = __webpack_public_path__ + "static/media/lens_classic-Vivid.32707556.png";